import { useCallback } from 'react';

import type { NotificationCategoryInput } from '__generated__/globalTypes';
import type { NotificationGroup } from 'lib/notifications';
import {
  notificationCategoryTypes,
  notificationGroups,
} from 'lib/notifications';

export const useGetNotificationCategories = () => {
  return useCallback(
    (groups: NotificationGroup[]): NotificationCategoryInput[] =>
      groups
        .flatMap(group =>
          notificationGroups[group].map(category => ({
            name: category,
            type: notificationCategoryTypes[category],
          }))
        )
        .filter(({ type }) => type !== 'ManagerProgressionNotification'),
    []
  );
};
